export const isUnicodeEmoji = (str: string): boolean => {
  // eslint-disable-next-line no-misleading-character-class
  const emojiRegex = /^(?:[\p{Emoji_Presentation}\u200d\uFE0F]+)$/u;
  return emojiRegex.test(str);
};
